import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FC, useState } from 'react'
import { InsightPaywall } from 'src/components/insights/types'
import { Colors, Shapes } from 'src/components/theme'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[5]}px;
  background-color: ${Colors.bgDark};
  padding: ${Shapes.spacing[6]}px;
  border-radius: ${Shapes.borderRadius}px;
`
const SynopsisRow = styled.div`
  display: flex;
  gap: ${Shapes.spacing[5]}px;
  align-items: center;
`
const SynopsisImageHoverControl = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  z-index: 1;
  background: rgba(0, 0, 0, 0.15);
  border-radius: ${Shapes.borderRadius}px;
  transition: background-color 0.2s;
`
const SynopsisImageHoverText = styled(Typography)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 3px 12px;
  border-radius: 12px;
  color: ${Colors.neutral500};
`

const SynopsisImageWrapper = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;

  &:hover {
    ${SynopsisImageHoverControl} {
      display: none;
    }
  }
`

const SynopsisImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  border-radius: ${Shapes.borderRadius}px;
  box-shadow: ${Colors.BOX_SHADOW};
`
const SynopsisDescription = styled.div`
  flex: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[4]}px;
`

type InsightLockedSynopsisProps = {
  synopsis?: InsightPaywall['synopsis']
  style?: React.CSSProperties
}

type SynopsisImgProps = {
  image: string
  imagePlaceholder?: string
}
const SynopsisImg: FC<SynopsisImgProps> = ({ image, imagePlaceholder }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <SynopsisImageWrapper>
      <SynopsisImageHoverControl>
        <SynopsisImageHoverText>Hover to view</SynopsisImageHoverText>
      </SynopsisImageHoverControl>
      <SynopsisImage
        src={(isHovered ? image : imagePlaceholder) ?? 'https://placehold.co/316x180/white/white'}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
    </SynopsisImageWrapper>
  )
}

export const InsightLockedSynopsis: FC<InsightLockedSynopsisProps> = ({ synopsis, style }) => {
  if (!synopsis) {
    return null
  }

  return (
    <Wrapper style={style}>
      {synopsis.map((item, index) => (
        <SynopsisRow key={item.image + index}>
          <SynopsisImg image={item.image} imagePlaceholder={item.imagePlaceholder} />
          <SynopsisDescription>
            <Typography variant="title2" color={Colors.textDark}>
              {item.title}
            </Typography>
            <Typography variant="textmdm" color={Colors.textMedium}>
              {item.description}
            </Typography>
          </SynopsisDescription>
        </SynopsisRow>
      ))}
    </Wrapper>
  )
}
